import script from "./TournamentSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./TournamentSummary.vue?vue&type=script&setup=true&lang=js"

import "./TournamentSummary.vue?vue&type=style&index=0&id=48929d3b&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../../Users/kmg/Documents/VS Code/Classwork/poker-session-tracker-vue3/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48929d3b"]])

export default __exports__